module.exports = __webpack_public_path__ + "images/Eventbrite-4fff7e.png";